<!--
 * @Description: 
 * @Date: 2022-05-24 10:57:37
-->
<template>
  <div>
    <el-row type="flex" justify="end" class="pb10" align="middle">
      是否允许超量审核：
      <el-switch
        v-model="isExcessAudit"
        active-text="是"
        :active-value="1"
        inactive-text="否"
        :inactive-value="0"
      ></el-switch>
    </el-row>
  </div>
</template>
<script>
import { record } from '@/api/ajax';

export default {
  name: 'isExcessAudit',
  data() {
    return {
      isExcessAudit: this.$store.state.homeProject.isExcessAudit
    };
  },

  watch: {
    async isExcessAudit(v) {
      if (+v !== +this.value) {
        const {
          data: { code }
        } = await record.openExcessAudit({
          isExcessAudit: v,
          projectId: this.$store.state.homeProject.id
        });
        this.$notify.closeAll();
        this.$notify.info({
          duration: 6000,
          title: v === 0 ? '禁止超量审核' : '允许超量审核',
          message:
            v === 0
              ? '所有超过预采购任务量的任务不允许审核通过\n' +
                '\n' +
                '并置于列表最底部'
              : '所有超过预采购任务量的任务可以审核通过'
        });
        if (+code === 1) {
          await this.$store.dispatch('syncProjectInfo');
          await this.$emit('tableSearch');
        }
        // await this.getPageList(1);
      }
    }
  }
};
</script>
